<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>FILTRI</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col md="3" sm="5" xs="12">
                                <v-select
                                    :items="shopList"
                                    v-model="filters.selectedShop"
                                    label="Negozio"
                                    item-text="description"
                                    item-value="id"
                                    @change="getTestate"
                                >
                                </v-select>
                            </v-col>
                            <v-col md="3" sm="5" xs="12">
                                <v-select
                                    :items="types"
                                    v-model="filters.selectedType"
                                    label="Tipo Lista"
                                    item-text="name"
                                    item-value="value"
                                    @change="getTestate"
                                >
                                </v-select>
                            </v-col>
                            <v-col md="6" sm="5" xs="12"> </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <v-card>
                    <v-data-table
                        dense
                        :headers="tableHeaders"
                        :items="testateList"
                        :items-per-page="50"
                        :footer-props="{
                            'items-per-page-options': [20, 50, 100, 200, -1],
                        }"
                    >
                        <template v-slot:item.XX_CHIAVEDOC="{ item }">
                            <b
                                ><a
                                    :href="'#'"
                                    @click="getRigheOrdine(item.XX_CHIAVEDOC)"
                                    >{{ item.XX_CHIAVEDOC }}</a
                                >
                            </b>
                        </template>
                        <template v-slot:item.TD_DATORD="{ item }">
                            {{ $moment(item.TD_DATORD).format("DD/MM/YYYY") }}
                        </template>
                        <template v-slot:item.TD_DATCONS="{ item }">
                            {{ $moment(item.TD_DATCONS).format("DD/MM/YYYY") }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" scrollable>
            <v-card>
                <v-card-title
                    >Dettaglio Ordine &nbsp;<b>{{
                        currentCodiceItem
                    }}</b></v-card-title
                >
                <v-card-text>
                    <div v-if="this.filters.selectedShop != 'CM'">
                        <h3>Totale: {{ calcoloTotale() | formatEuro }}</h3>
                    </div>
                </v-card-text>
                <v-card-text>
                    <v-data-table
                        dense
                        :headers="dialogTableHeaders"
                        :items="righeList"
                        :items-per-page="50"
                        :footer-props="{
                            'items-per-page-options': [20, 50, 100, 200, -1],
                        }"
                    >
                        <template v-slot:item.foto="{ item }">
                            <div style="text-align: center">
                                <img
                                    height="80px"
                                    :src="getImagePath(item.MO_CODART)"
                                    onerror="javascript: this.src='/no_image.jpg';"
                                />
                            </div>
                        </template>
                        <template v-slot:item.MO_CODART="{ item }">
                            <a
                                class="font-weight-bold"
                                :href="'/product?id=' + item.MO_CODART"
                                target="_blank"
                                >{{ item.MO_CODART }}</a
                            >
                        </template>
                        <template v-slot:item.MO_PREZZO="{ item }">
                            {{ item.MO_PREZZO | formatEuro }}
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="d-flex align-end flex-column">
                    <v-btn @click="dialog = false"> Close </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<style lang="scss"></style>
<script>
import requests from "../requests";
import helpers from "../helpers";
export default {
    name: "testate-ordini-page",
    data: () => {
        return {
            loading: false,
            shopList: [],
            dialog: false,
            currentCodiceItem: null,
            tableHeaders: [
                {
                    text: "Chiave",
                    align: "start",
                    value: "XX_CHIAVEDOC",
                    sortable: false,
                },
                {
                    text: "Data Ordine",
                    value: "TD_DATORD",
                },
                {
                    text: "Data Consegna",
                    value: "TD_DATCONS",
                },
                {
                    text: "Num Ordine",
                    value: "TD_NUMORD",
                },
                {
                    text: "Tot Doc",
                    value: "TD_TOTDOC",
                },
                {
                    text: "Tot Merce",
                    value: "TD_TOTMERCE",
                },
            ],
            dialogTableHeaders: [
                {
                    value: "foto",
                    sortable: false,
                },
                {
                    text: "Cod.Art",
                    align: "start",
                    value: "MO_CODART",
                    sortable: false,
                },
                {
                    text: "Descrizione",
                    value: "MO_DESCR",
                },
                {
                    text: "Barcode",
                    value: "MO_BARCODE",
                },
                {
                    text: "Data Consegna",
                    value: "MO_DATCONS",
                },
                {
                    text: "Qta",
                    value: "MO_QUANT",
                },
                {
                    text: "Prezzo",
                    value: "MO_PREZZO",
                },
            ],
            testateList: [],
            righeList: [],
            filters: {
                selectedShop: null,
                selectedType: "R",
            },
            types: [
                {
                    name: "Impegno Cliente",
                    value: "R",
                },
                {
                    name: "Ordine Fornitore",
                    value: "O",
                },
            ],
        };
    },

    async mounted() {
        await this.getShopList();
        this.getTestate();
    },

    methods: {
        getShopList() {
            return requests.getShopList().then((res) => {
                this.shopList = res.data;
                this.shopList.push({
                    description: "CASA MADRE",
                    id: "CM",
                });

                if (this.filters.selectedShop == null)
                    this.filters.selectedShop = res.data[0].id;
            });
        },
        getTestate() {
            let d = {
                tipork: this.filters.selectedType,
                shop_id: this.filters.selectedShop,
            };
            requests.getTestate(d).then((res) => {
                this.testateList = res.data;
            });
        },

        getRigheOrdine(codice) {
            this.currentCodiceItem = codice;
            requests.getRigheOrdini(codice).then((res) => {
                this.righeList = res.data;
                this.dialog = true;
            });
        },
        getImagePath(a) {
            return helpers.getImagePath(a);
        },

        calcoloTotale() {
            let tot = 0;
            _.each(this.righeList, (val) => {
                tot += val.MO_PREZZO * val.MO_QUANT;
            });
            return tot;
        },
    },

    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    },
};
</script>
